import {ReactElement} from 'react';
import {classNames} from 'primereact/utils';

import {Icon} from '@kasta-io/components';

import s from '../../signin/signin.module.scss';

interface Props {
  type: 'fixed' | 'expanded' | 'compressed';
  onSubmit?: () => Promise<void>;

  icon?: string;
  title?: string;
  subtitle?: string;

  removeMainContainerPadding?: boolean;
  fixIconMargin?: boolean;

  Change?: ReactElement<any, any>;
  Content?: ReactElement<any, any>;
  Footer?: ReactElement<any, any>;
}

/*
 * This form has three rendering modes:
 * - fixed, which is the default, used in the first login page
 * - compressed, used in the rest of the login pages
 * - expanded, used in all other auth pages
 */

const BasicForm = ({
  type,
  removeMainContainerPadding,
  fixIconMargin,
  icon,
  title,
  subtitle,
  onSubmit,
  Change,
  Content,
  Footer,
}: Props) => {
  const containerClassNames = classNames(s.commonForm, {
    [s.fixedForm]: type === 'fixed',
    [s.expandedForm]: type === 'expanded',
    [s.compressedForm]: type === 'compressed',
    [s.removeTopPadding]: removeMainContainerPadding,
    [s.fixIconMargin]: fixIconMargin,
  });

  return (
    <main className={containerClassNames}>
      <form onSubmit={onSubmit}>
        <div>
          {icon && <Icon name={icon} size={72} />}
          {title && <h1>{title}</h1>}
          <p>{subtitle}</p>
          {!!Change && <div className={s.flex}>{Change}</div>}
          {Content}
        </div>

        {!!Footer && <div>{Footer}</div>}
      </form>
    </main>
  );
};

export default BasicForm;
